import { capitalize } from "lodash";
import { ChevronDown } from "react-feather";
import { Select } from "../../Select";

type VisibilitySelectProps = {
  value: string;
  onChange: (val: string) => void;
};

export const VisibilitySelect: React.FC<VisibilitySelectProps> = ({ onChange, value }) => (
  <Select.Select
    value={value}
    onValueChange={(val) => {
      onChange(val);
    }}>
    <Select.Trigger ariaLabel="visibilitySelector">
      <Select.Value>{capitalize(value)}</Select.Value>
      <Select.Icon>
        <ChevronDown className={"h-5"} />
      </Select.Icon>
    </Select.Trigger>
    <Select.Content>
      <Select.Viewport>
        <Select.Item value={"private"} key={"private"}>
          <Select.ItemText>Private</Select.ItemText>
        </Select.Item>
        <Select.Item value={"clinic"} key={"clinic"}>
          <Select.ItemText>Clinic</Select.ItemText>
        </Select.Item>
        <Select.Item value={"global"} key={"global"}>
          <Select.ItemText>Global</Select.ItemText>
        </Select.Item>
      </Select.Viewport>
    </Select.Content>
  </Select.Select>
);
